import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';   
import { CategoryModel } from '@ascschool/model/category/category-model.model'; 
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';         
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeOfOrganizationService } from '@ascschool/services/category/type-of-organization.service';
import { KindOfSupportService } from '@ascschool/services/category/kind-of-support.service';
import { CareerService } from '@ascschool/services/category/career.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { HinhThucHoc } from '@ascschool/model/category/hinh-thuc-hoc.model';
import { CapTrucThuoc } from '@ascschool/model/category/cap-truc-thuoc.model';
import { CapTrucThuocService } from '@ascschool/services/category/cap-truc-thuoc.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-pop-up-phuong-thuc-giao-duc',
  templateUrl: './pop-up-phuong-thuc-giao-duc.component.html',
  styleUrls: ['./pop-up-phuong-thuc-giao-duc.component.scss']
})
export class PopUpPhuongThucGiaoDucComponent implements OnInit {
  @Input() value: any;
  isEditMode = false;
  @ViewChild("form", { static: false }) formElement: ElementRef;
  captructhuoc = new CapTrucThuoc();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private service: ModesOfEducationService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    if (this.value && this.value.id > 0) { 
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.captructhuoc.id = this.value.id;
      // console.log(this.captructhuoc);
      this.validateForm = this.fb.group({
        id : this.value.id,
        code: [this.value.code, [Validators.required]],
        name: [this.value.name, [Validators.required]], 
      });  
    } else {
      this.captructhuoc = new CapTrucThuoc();
      this.isEditMode = false;
      this.validateForm = this.fb.group({
        code: [null, [Validators.required]],
        name: [null, [Validators.required]], 
      });
    }

  }
  GetById(id: number){
    this.service.getById(id).subscribe((res: any) => {
      this.captructhuoc = res;    
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){  
    if (this.validateForm.valid){
      this.captructhuoc = this.validateForm.value;  
      this.service.addOrUpdate(this.captructhuoc).subscribe((res) => {
        if (res.statusCode === 0){
          this.notification(res);
          this.close();
        }else{
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      }
      );
    }else{
      this.utilsService.findInvalidControlsbyForm(this.validateForm,this.formElement);
    }
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
 
}
